import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.configuration_api.application_permissions;

const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Cached API wrapper for this namespace/group
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'configuration_api',
  group: 'application_permissions',
  defaultTtl: '10m',
  hashLargeSegments: true,
  emitMeta: true,
});

// Get all application permissions
export const GetAllApplicationPermissions = async () => {
  return await retryWithBackoff(() =>
    cachedApi.get('/GetAllApplicationPermissions')
  );
};

// Create a new application permission
export const CreateApplicationPermission = async (data: {
  application_permission_name: string;
  application_permission_description?: string;
  affect_money?: boolean;
  category: string;
  subcategory?: string;
  permission_type?: string;
}) => {
  const res = await retryWithBackoff(() =>
    api.post('/CreateApplicationPermission', data)
  ) as any;
  await cachedApi.clear();
  return res;
};

// Delete an application permission
export const DeleteApplicationPermission = async (permissionId: number) => {
  const res = await retryWithBackoff(() =>
    api.delete(`/DeleteApplicationPermission/${permissionId}`)
  ) as any;
  await cachedApi.clear();
  return res;
};

// Update permission type (read, create, update, delete)
export const UpdateApplicationPermissionType = async (permissionId: number, permission_type: string) => {
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateApplicationPermissionType/${permissionId}`, { permission_type })
  ) as any;
  await cachedApi.clear();
  return res;
};

// Update permission name
export const UpdateApplicationPermissionName = async (permissionId: number, application_permission_name: string) => {
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateApplicationPermissionName/${permissionId}`, { application_permission_name })
  ) as any;
  await cachedApi.clear();
  return res;
};

// Update permission category and subcategory
export const UpdateApplicationPermissionCategory = async (permissionId: number, category: string, subcategory?: string) => {
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateApplicationPermissionCategory/${permissionId}`, { category, subcategory })
  ) as any;
  await cachedApi.clear();
  return res;
};

// Toggle affect_money field
export const ToggleApplicationPermissionAffectMoney = async (permissionId: number) => {
  const res = await retryWithBackoff(() =>
    api.put(`/ToggleApplicationPermissionAffectMoney/${permissionId}`)
  ) as any;
  await cachedApi.clear();
  return res;
};

// Update permission description
export const UpdateApplicationPermissionDescription = async (permissionId: number, application_permission_description: string) => {
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateApplicationPermissionDescription/${permissionId}`, { application_permission_description })
  ) as any;
  await cachedApi.clear();
  return res;
};